// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"Modal_modalOverlay__sayXU","modal":"Modal_modal__TgcP9","closeButton":"Modal_closeButton__PLVNR","modalContent":"Modal_modalContent__S4Sqv"};